export const APPSFLYER = {
    smartBannerId: '6d6ce227-f51a-4f87-8202-c1d1b3138d35',
}